// extracted by mini-css-extract-plugin
export default {"info-box":"InfoBox_info-box__THO+t","card":"InfoBox_card__6u15d"};